module.exports = __webpack_public_path__ + "img/github.49eada50.svg";